<script>
import AlertNotification from '@components/alert-notification'

export default {
  name: 'AlertWidget',
  components: {
    AlertNotification
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.componentData.icon;
    },
    message() {
      return this.componentData.text;
    },
    show() {
      return this.componentData.show;
    }
  }
}
</script>

<template>
  <AlertNotification
    v-if="show"
    :icon-image="icon"
    :text-message="message"
  />
</template>

<style lang="scss" module>
@import '@design';
</style>
